<div
  fxLayout="column"
  fxLayoutGap="16px"
  fxLayoutAlign="center center"
  class="body-wrapper"
>
  <mat-toolbar fxLayout="colum" color="primary">
    <span><a [routerLink]="['/msgs']" mat-button>response.life.edu</a></span>

    <span *ngIf="isAdmin">
      <a [routerLink]="['/admin/templates']" mat-button>Templates</a>
    </span>

    <span fxFlex="1 1 auto"></span>

    <span *ngIf="loggedIn"
      ><button type="button" mat-button (click)="signOut()">
        Sign Out
      </button></span
    >
  </mat-toolbar>
  <div fxFlex>
    <router-outlet></router-outlet>
  </div>
</div>
